import React from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/Home/HeroSection';
import FeaturedProperties from '../components/Home/FeaturedProperties';
import ServicesSection from '../components/Home/ServicesSection';
import StatsSection from '../components/Home/StatsSection';
import TestimonialsSection from '../components/Home/TestimonialsSection';
import CTASection from '../components/Home/CTASection';

const Home = () => {
  return (
    <Box>
      <HeroSection />
      <FeaturedProperties />
      <ServicesSection />
      <StatsSection />
      <TestimonialsSection />
      <CTASection />
    </Box>
  );
};

export default Home;
